const addUserGroup = {
    tagFilters: '/dynames/v1/label/getLabelFilterOptions',
    loadPopulationSize: '/dynames/v1/segment/getSegmentPackageCount',
    addUserGroup: '/dynames/v1/segment/createSegmentPackage',
    getSegmentPackageDetail: '/dynames/v1/segment/getSegmentPackageDetail',
    getUserRole: '/api/v2/userGroup/getUserRole',
    getDisabledTags: '/api/v2/userGroup/getDisabledTags',
    shareUserGroup: '/api/v2/userGroup/shareUserGroup',
    getDimTagValue: '/api/tag/getDimTagValue',
    
};
const editItemUserGroup = {
    updateSubUserGroup:'/api/v2/userGroup/updateSubUserGroup',
    delSubPopulation:'/api/v2/userGroup/delSubPopulation',
    copyItemUserGroup:'/api/v2/userGroup/copyCombineUserGroup',

};
const reportLog = {
    getTodayPushRecord:'/api/task/record/getTodayPushRecord',
    getNextdayPushRecord:'/api/task/record/getNextdayPushRecord',
    getGroupJobAction:'/api/job/today/getGroupJobAction',
    getTodayPushRecordStrategy: '/api/task/record/getTodayPushRecordStrategy',
    getNextdayPushRecordStrategy: '/api/task/record/getNextdayPushRecordStrategy'

}

// 数据分析=>用户画像
const userProfile = {
    getUserProfile: '/api/userProfile/getUserProfile',
    getUserIdList: '/api/userProfile/getUserIdList',
    // getUserProfileBuyTab: '/api/userProfile/getUserProfileBuyTab',
}

const userGroupList = {
    userGroupList: '/dynames/v1/segment/getSegmentPackageList',
    userGroupListOption: '/dynames/v1/segment/getSegmentPackageOptionList',
    getGroupType: '/api/v2/userGroup/getGroupType',
    exportUserGroup: '/api/v2/userGroup/exportUserGroup',
    delPopulation: '/dynames/v1/segment/delSegmentPackage',
    disableUserGroup: '/dynames/v1/segment/disableSegmentPackage',
    // randomUserGroup: '/api/userGroup/randomUserGroup',
    // authorityButton: '/api/v2/userGroup/authorityButton',
    // batchDisable: '/api/userGroup/batchDisable',
    systemManagementButton: '/api/userManagement/queryMenuTab',
    uploadGroupApi:'/api/v2/userGroup/uploadGroup',
    uploadUserGroup:'/dynames/v1/segment/uploadSegmentPackage',
    checkPeopleApi:'/dynames/v1/segment/checkPeople',
    userGroupItemList: '/api/v2/userGroup/userGroupItemList'
}

const tagsOverview = {
    getTagMapTree: '/api/tag/queryOverviewTags',
}

// 其他设置 => 日志事件
const logEvent = {
    getLogDataApi: '/api/setting/logEvent/getLogData',
    getLogType: '/api/setting/logEvent/getLogType',
}

const tagManagement = {
    queryTagLevel: '/api/tag/queryTagLevel',
    updTag: '/dynames/v1/label/updLabel',
    getFavorTag: '/api/tag/getFavorTag',
    updFavorTag: '/api/tag/updFavorTag',
    batchUpdTag: '/api/tag/batchUpdTag',
    // getTagTreeMenu: '/api/tag/getTagTreeMenu',
    getTagsByLevel: '/dynames/v1/label/getLabelListByLevel',
    queryRoleTags: '/api/tag/queryRoleTags',
    getFitlerMyTagTree: '/dynames/v1/label/getLabelTreeOptions',
    getChartByDim: '/api/tag/getChartByDim',
    searchTagVal: '/api/tag/searchTagVal',
    getTagsByName: '/dynames/v1/label/searchLabelValue',
}
const userList = {
    checkUserExistence:'/dynames/v1/user/checkUserExistence',
    addExistingUser:'/dynames/v1/user/addExistingUser',
    updateSubscription:'/dynames/v1/authority/switchSubscription',
    getSubscriptionList:'/dynames/v1/authority/getSubscriptionOptions',
    addUser: '/dynames/v1/user/createUser',
    delUser: '/dynames/v1/user/delUser',
    disableUser: '/dynames/v1/user/disableUser',
    updUser: '/dynames/v1/user/updUser',
    queryAllUser: '/dynames/v1/user/getAllUserList',
    queryRoles: '/dynames/v1/role/getRoleSelectOption',
    getUser: '/api/userManagement/getUser',
    updPwd: "/dynames/v1/user/updatePassword",
    updTimezone: "/dynames/v1/tenant/updateTimeZone",
}
//角色管理
const roleManagement = {
    getRoleApi:'/dynames/v1/role/getAllRoleList',
    getRoleById:'/dynames/v1/role/getRoleById',
    getResourcesOption: '/dynames/v1/resource/getResourcesOption',
    getButtonsOption: '/dynames/v1/resource/getButtonsOption',

    delRoleApi:'/dynames/v1/role/delRole',
    addRoleApi:'/dynames/v1/role/createRole',
    editRoleApi:'/dynames/v1/role/updRole',
    getRoleSelectOption: '/api/role/getRoleSelectOption',
    getOpHis: '/api/role/getOpHis',
    getConfigType: '/api/userManagement/getConfigType',
    getConfigInfo: '/api/userManagement/getConfigInfo',
    addConfig: '/api/userManagement/addConfig',
}

const tagAuthorityManagement = {
    getAllUserTagAuthority: '/api/tag/getAllUserTag',
    getTreeOptions: '/api/tag/getTreeOptions',
    // getSubmitRecordList:'/api/tag/getTagHisList',
    updTagAuthorityByUserId: '/api/tagAuthority/updTagAuthorityByUserId',
    applyTagAuthority: '/api/tag/applyTag',
    getApplyLogs: '/api/tagAuthority/getApplyLogs',
    getRoleSelectOption: '/api/tagAuthority/getRoleSelectOption',
    getBrandOptions: '/api/tagAuthority/getBrandChannels',
    getTagsByChannel: '/api/tagAuthority/getTagsByChannel',
    getApplyRecord: '/api/tagAuthority/getApplyRecord',
    enableDisableTagAuthority:'/api/tag/enableDisableTag',
    addTagAuthority:'/api/tag/addNewTag',
    getCheckedTreeOptions: '/api/tag/getCheckedTreeOptions',
}


const menuButtonManagement = {
    queryUserList: '/api/button/queryUserList',
    applyButtonAuthority: '/api/button/applyButtonAuthority',
    applyButton: '/api/button/applyButton',
}

const login = {
    // loginApi:'https://sso.jnby.com:8443/cas/login?service=http://127.0.0.1:9090/api/userManagement/login'
    isLoginAnother:'/dynames/v1/authority/validateToken',
    loginApi:'/dynames/v1/authority/login',
    singleSignOn:'/dynames/v1/authority/msSsoLogin',
    updUserStyle:'/api/userManagement/updUserStyle',
    getMenu:'/dynames/v1/resource/getUserMenu',
    loginOutApi:'/api/userManagement/loginOut',
    getButtonPermission:'/dynames/v1/usage/getUsageSummary',
}

// 系统设置=>系统管理=>资源菜单
const sourceMenuManagement = {
    getAllMenu: '/api/menu/getAllMenu',
    updMenu: '/api/menu/updMenu'
}

// 数据分析 => 人群看板
const userAnalysis = {
    getOption: '/api/userGroupAnalysis/getOption',// 下拉人群列表
    queryCharsById: '/api/userGroupAnalysis/queryCharsById',// group_id=人群id;tab=区分哪个板块的数据 get方法
}
// 其他设置 => AIP设置
const ChannelApply = {
    getAppList: '/api/app/getAppList',
    createApp: '/api/app/createApp',
    getAppIdAndKey: '/api/app/getAppIdAndKey',
    updApp: '/api/app/updApp',
    updChannel: '/api/app/updChannel',
    enableDisableApp: '/api/app/enableDisableApp',
    getApiExample:'/api/app/getApiExample',
    getApiChannel:'/api/app/getApiChannel',
    getAllApiChannel:'/api/app/getAllApiChannel',
    getApiPercent:'/api/app/getApiPercent',
}

const homeSetting = {
    getHomeSettingUserGroup: '/api/systemManage/getHomeSettingUserGroup',
    updateGroupUser: '/api/systemManage/updateGroupUser',
    getUserGroupNow: '/api/systemManage/getUserGroupNow'
}

//数据分析 => 大盘看板
const homeAnalysis = {
    getCharts: '/api/index/getCharts', //大盘看板
    getSelectOpts: '/api/index/getSelectOpts', //大盘看板下拉选项
    getDataFreshTime: '/api/index/getDataFreshTime',
}
const areaAuthorityManagement={
    getAreaTree:'/api/areaAuthority/getAreaTree',
    applyAreaAuthority:'/api/areaAuthority/applyAreaAuthority',
    getRoleAreaAuthority:'/api/areaAuthority/getRoleAreaAuthority',
}
// 运营看板
const operationAnalysis = {
    getOpNewUserCharts: '/api/operationAnalysis/getOpNewUserCharts',
    getOpRepeatByCharts: '/api/operationAnalysis/getOpRepeatByCharts',
}

const launchStrategy = {
    getStrategyList: '/dynames/v1/strategy/getStrategyList',
    getActionPushDetailById: '/dynames/v1/strategy/getActionPushDetailById',
    getStrategyDetail: '/dynames/v1/strategy/getStrategyDetail',
    saveStrategy: '/api/strategy/saveStrategy',
    getStrategyTypeTree: '/dynames/v1/strategy/getStrategyTypeTree',
    getStrategyParentType: '/api/strategy/getStrategyParentType',
    getStrategyType: '/api/strategy/getStrategyType',
    addStrategyType: '/api/strategy/addStrategyType',
    getStrategyConfigList: '/api/strategy/getStrategyConfigList',
    getGlobalConfig: '/api/strategy/getGlobalConfig',
    delStrategyById: '/api/strategy/stopStrategyById',
    delStrategyActionById: '/dynames/v1/strategy/delStrategyActionById',
    deleteStrategyById:'/api/strategy/deleteStrategyById',// 删除策略
    saveStrategyConfig: '/api/strategy/saveStrategyConfig',
    saveStrategyAction: '/dynames/v1/strategy/createStrategyAction',
    saveGlobalStrategyConfig: '/api/strategy/saveGlobalStrategyConfig',
    searchStrategyJoinConfigList: '/api/strategy/searchStrategyJoinConfigList',
    // checkModifyDeadline: '/api/strategy/checkModifyDeadline', //操作权限
    changeOrderApi: '/api/strategy/changeOrder', //操作权限
    // checkPriorityModifyStatus: '/api/strategy/checkPriorityModifyStatus',
    saveStrategyOrderList: '/api/strategy/saveStrategyOrderList',
    export4Excel: '/api/strategy/export4Excel',
    recoveryStrategy: '/api/strategy/recoveryStrategy', // 恢复策略的
    delStrategyBack: '/api/strategy/delStrategyBack', // 徹底刪除接口
    rankStrategyPriority: '/api/strategy/rankStrategyPriority',// 优先级排序
    getDistGroupList:'/api/strategy/getDistGroup2',// 策略重排下拉选项
    getStrategyAction: '/dynames/v1/strategy/getAllStrategyActionList', // 策略行为查询
    createStrategy: '/dynames/v1/strategy/createStrategy', //策略新增（智能优惠券）
    updStrategy: '/dynames/v1/strategy/updStrategy', //策略新增（智能优惠券）
    delStrategyById: '/dynames/v1/strategy/delStrategyById', //策略新增（智能优惠券）
    getSupplier: '',
    getEmail: '',
}
const ContentListService = {
    getEmailTemplateOptions:'/dynames/v1/content/getEmailTemplateOptions',
    getContentList:'/dynames/v1/content/getContentList',
    getAllContentList:'/dynames/v1/content/getContentOptionList',
    addContent:'/dynames/v1/content/createContent',
    addEmailContent:'/dynames/v1/content/createEmailContent',
    delContent:'/dynames/v1/content/delContent',
    updContent:'/dynames/v1/content/updContent',
    updEmailContent:'/dynames/v1/content/updEmailContent',
    getContentById:'/dynames/v1/content/getContentById',
    // getSmsSignList:'/api/content/getSmsSignList',
    submitReview:'/api/content/submitReview',
    submitReviews:'/api/content/submitReviews',
    getMiniProgList:'/api/content/getMiniProgList',
    contentIsUse:'/api/content/isUse',
    // getList:'/api/content/getList',
    
    getContentDictList: '/api/content/getContentDictList',
    saveContentDict: '/api/content/saveContentDict',
    //getSMSList: '/dynames/v1/content/getContentOptionList',
    getWeComSender: '/api/strategy/getWeComSender',
    getExpandContentList: '/api/content/getExpandContentList',
    // tag
    getContentTagList: '/api/content/getContentTagDTO',
    getContentTagByPid: '/api/content/getContentTagByPid',
    addContentTag: '/api/content/addContentTag',
    updateContentTag: '/api/content/updateContentTag',
    deleteContentTag: '/api/content/deleteContentTag',
}

// 运营看板
const coupon = {
    //getAllCoupon: '/api/coupon/getAllCoupon',
    getCouponChannelType: '/api/coupon/getCouponChannelType',
    getUpdCouponYseOrNo:'/api/coupon/getUpdCouponYseOrNo',
    addCoupon: '/api/coupon/addCoupon',
    updCoupon: '/api/coupon/updCoupon',
    delCouponById: '/api/coupon/delCouponById',
    checkCoupon: '/api/coupon/checkCoupon',
    getExpandCouponList: '/api/coupon/getExpandCouponList',
    getAutoMeta: '/api/ai/getAutoMeta',// 智能优惠券（产品选择来源）
    getCouponNumList: '/api/ai/getCouponNumList',// 智能优惠券（优惠券数量列表）
    getCouponBaseList: '/api/ai/getCouponBaseList',// 智能优惠券（获取智能优惠券保底列表）
    saveAutoCouponProductConfig: '/api/ai/saveAutoCouponProductConfig',// 智能优惠券(保存)
    getAutoCouponProductConfig: '/api/ai/getAutoCouponProductConfig',// 智能优惠券详情、编辑信息
    getAutoParams: '/api/ai/v3/getAutoParams',// 智能优惠券详情、编辑信息
    uploadCouponNumExcel: '/api/ai/uploadCouponNumExcel',// 优惠券数量上传
}
const  strategyGroupJob = {
    // getGroupJob :'/api/job/getGroupJob',
    pushResult :'/api/job/pushResult',
    resetPushResult :'/api/job/resetPushResult',
    updateTagDataVersion :'/api/strategy/updateTagDataVersion',
    getGroupJobByDate: '/api/job/getGroupJobByDate',
    getGroupJobDateByDate: ' /api/job/getGroupJobDateByDate',
    setAutoPushResultTime: '/api/job/setAutoPushResultTime',
    runFilter: '/api/job/runFilter',
    runSqlAlgo: '/api/job/runSqlAlgo',
    runSyncStrategy2Hive: '/api/job/runSyncStrategy2Hive',
    setAutoRawDataTime: '/api/job/setAutoRawDataTime',
    getDayPushIndex: '/api/job/getDayPushIndex',
    getGroupJobMonthStatus: '/api/job/getGroupJobMonthStatus',
    getMonthPushIndex: '/api/job/getMonthPushIndex',
    getTodayPushRecordInfo: '/api/task/record/getTodayPushRecordInfo',
    getNextdayPushRecordInfo: '/api/task/record/getNextdayPushRecordInfo'
}

const ruleManagement = {
    getFilterRuleList: '/api/rule/getFilterRuleList',
    saveFilterRuleDefaultConfig: '/api/rule/saveFilterRuleDefaultConfig',
    getFilterRuleDefaultConfigSelected: '/api/rule/getFilterRuleGroup',
    addFilterRule: '/api/rule/addFilterRule',
    updFilterRule: '/api/rule/updFilterRule',
    delFilterRule: '/api/rule/delFilterRule',
    // getFilterRuleGroupList: '/api/rule/getFilterRuleGroupList',
    addFilterRuleGroup: '/api/rule/addFilterRuleGroup',
    updFilterRuleGroup: '/api/rule/updFilterRuleGroup',
    delFilterRuleGroupById: '/api/rule/delFilterRuleGroupById',
}

const addUserGroupV2 = {
    loadPopulationSize:'/dynames/v1/segment/getSegmentPackageCount',
    addUserGroup: '/dynames/v1/segment/createSegmentPackage',
    addCombineUserGroup: '/api/v2/userGroup/addCombineUserGroup',
    randomNumber: '/api/v2/userGroup/randomNumber',
}

// 自定义人群
const customGroupV2 = {
    addCustomGroup: '/api/v2/userGroup/addCustomGroup', // 保存人群接口 post
    loadCustomSize: '/api/v2/userGroup/loadCustomSize', // 查询人群数量接口 get
    // queryUserGroupInfo: '/api/v2/userGroup/queryUserGroupInfo', // 查询人群信息 get
}

const resultApi = {
    getOption:'/api/resDash/analData/getOptions',
    getOptionsByLevel: '/api/resDash/analData/getOptionsByLevel',
    getAnal:'/api/resDash/analData/getAnalData',
    getAnalDatasCompare:'/api/resDash/analData/getAnalDatasCompare'
}

// BI
const resultDashboard = {
    getCityMapping: '/api/charts/getCityMapping',
    getChannelMapping: '/api/charts/getChannelMapping',
    getCustomers: '/api/charts/getCustomers',
    get4Charts: '/api/charts/get4Charts',
    getRCharts: '/api/charts/getRCharts',
    getStrategyType: '/api/charts/getStrategyType',
    getCouponType: '/api/charts/getCouponType',
    getStratDetailTab: '/api/charts/getStratDetailTab',
    getStrategyDailyCharts: '/api/charts/getStrategyDailyCharts',
}

const strategyManagementApiV2 = {
    getStrategyParentTypeV2:'/api/strategy/getStrategyParentTypeV2',
    getTypeDataByLevelApi:'/api/strategy/getTypeDataByLevel',
    getParentOptionApi:'/api/strategy/getParentOption',
    checkIdApi:'/api/strategy/checkId',
    checkNameApi:'/api/strategy/checkName',
    addTypeApi:'/api/strategy/addType',
    updateTypeApi:'/api/strategy/updateType',
    delTypeApi:'/api/strategy/delType',
}
const blackWhiteList = {
    // 重构后
    getBlackWhiteList:'/dynames/v1/unSubscribe/getUnSubscribeList',
    addBlackWhiteList:'/dynames/v1/unSubscribe/createUnSubscribe',
    addByExcel:'/dynames/v1/unSubscribe/createBatchUnSubscribe',
    editBlackWhiteList:'/dynames/v1/unSubscribe/updUnSubscribe',
    deleteBlackWhiteList:'/dynames/v1/unSubscribe/delUnSubscribe',
    downloadTemplateExcel:'/dynames/v1/unSubscribe/downloadUploadTemplate',
    downloadErrorExcel:'/dynames/v1/unSubscribe/getErrorByExcel',
    uploadFile:'/dynames/v1/unSubscribe/uploadUnSubscribeFile',
    exportList:'/api/lists/exportExcel',

    // 重构前
    getStrategyWhiteList: '/api/strategy/getStrategyWhiteList', // 获取黑白名单列表
    addStrategyWhiteList: '/api/strategy/addStrategyWhiteList', // 添加黑白名单
    delStrategyWhiteList: '/api/strategy/delStrategyWhiteList', // 删除黑白名单
    updateStrategyWhiteList: '/api/strategy/updateStrategyWhiteList', // 更新黑黑名单
    getStrategyWhiteListGroup: '/api/strategy/getStrategyWhiteListGroup', // 获取分组
    addStrategyWhiteListGroup: '/api/strategy/addStrategyWhiteListGroup', // 新增分组
    getstrategyNameJoinConfig: '/api/strategy/getstrategyNameJoinConfig', // 策略下拉查询
}
const customizedRemoval = {
    getDistGroup: '/api/strategy/getDistGroup', //分组列表
    getDistStrategyMain: '/api/strategy/getDistStrategyMain', // 策略列表
    updateDistGroup: '/api/strategy/updateDistGroup', // 更新分组
    addDistGroup: '/api/strategy/addDistGroup', // 新增分组
    deleteDistGroupById: '/api/strategy/deleteDistGroupById', // 删除分组
}
const couponTag = {
    getCouponTagApi:'/api/coupon/getCouponTagDTO',
    getCouponTagByPidApi:'/api/coupon/getCouponTagByPid',
    addCouponTag: '/api/coupon/addCouponTag',
    updateCouponTag: '/api/coupon/updateCouponTag',
    deleteCouponTag: '/api/coupon/deleteCouponTag',
}
const robotTask = {
    getQwRobotList :'/api/strategy/getQwRobot',
    addQwRobot: '/api/strategy/addQwRobot',
    updateQwRobot: '/api/strategy/updateQwRobot',
    deleteQwRobot: '/api/strategy/deleteQwRobot'
}

const autoProduct = {
    productLevel3List :'/api/ai/getProductLevel3List',

}

// 智能启停
const intellControl = {
    getMetaList: '/api/ai/startStop/getMetaList',
    saveModel: '/api/ai/startStop/saveModel',
    getModelList: '/api/ai/startStop/getModel',
    delModel: '/api/ai/startStop/delModel',
    getUnusedStrategyIds: '/api/ai/startStop/getUnusedStrategyIds',
}

// 我的标签
const myTags = {
    getFavTagsByLevel: '/api/tag/getFavTagsByLevel',
    getFavTagsByName: '/api/tag/getFavTagsByName',
    updateFavTag: '/api/tag/updateFavTag',
}

// 素材上传
const materialUpload={
    getWeChatMiniProgramName:'/api/content/getWeChatMiniProgramName',
    getWechatOATemplateList:'/api/content/getWechatOATemplateList',
    uploadMaterial:'/api/cms/upload/uploadFile',
    getMaterialList:'/api/cms/upload/getUploadFiles',
    getCategoryList:'/api/cms/level/getTreeData',
    delSingleMaterial:'/api/cms/upload/delSingleMaterial',
    updUploadFiles:'/api/cms/upload/updUploadFiles',
    submit:'/api/cms/upload/submit',
    getTagsList:'/api/cms/tag/getTreeData',
    uploadAvatar:'/api/cms/upload/uploadAvatar',
    uploadAttachments:'/api/content/uploadAttachments',
    addLevel:'/api/cms/level/add',
    addTag:'/api/cms/tag/addTag',
    getTagMaxSort:'/api/cms/tag/getTagMaxSort'
}

const materialLibrary={
    getTableData:'/api/cms/material/mgt/getTableData',
    del:'/api/cms/material/mgt/del',
    update:'/api/cms/material/mgt/update',
    getExtTypes:'/api/cms/material/mgt/getExtTypes',
    downloadZip:'/api/cms/material/mgt/downloadZip',
    getDownloadZip:'/api/cms/material/mgt/getDownloadZip',
    editMaterialText:'/api/cms/material/mgt/editMaterialText',
    addTextMaterial:'/api/cms/material/mgt/addTextMaterial',
    getChannelList:'/api/cms/material/mgt/getTextChannel',
}

const materialDetail = {
    getItemInfo:'/api/cms/material/mgt/getItemInfo',
    getLevelData:'/api/cms/level/getLevelData',
    update:'/api/cms/level/update',
    del:'/api/cms/level/delete',
}

const materialTagManagement = {
    getTagData:'/api/cms/tag/getTagData',
    delTag:'/api/cms/tag/delTag',
    delTagLevel:'/api/cms/tag/delTagLevel',
    addTagLevel:'/api/cms/tag/addTagLevel',
    editTagLevel:'/api/cms/tag/updateTagLv',
    updateTag:'/api/cms/tag/updateTag',
}


const intelligentAll = {
    saveMsgToLib:'/api/aigc/saveMsgToLib',
    saveImgToLib:'/api/aigc/saveImgToLib',
    getStrategyContent:'/api/aigc/getStrategyContent',
    createCopywrite:'/api/aigc/generateMsg',
    generateImg:'/api/aigc/generateImg',
    getUrlByBase64:'/api/aigc/getUrlByBase64',
    saveEditedImg:'/api/aigc/saveEditedImg',
    getHistRecords:'/api/aigc/getHistRecords',
    setFavour:'/api/aigc/setFavour',
}


const statMemberBehavior={
    getDimensRegion: "/api/statMemberBehavior/getDimensRegion",
    queryMemberLevelSale: "/api/statMemberBehavior/queryMemberLevelSale",
    queryMemberSummary: "/api/statMemberBehavior/queryMemberSummary",
    queryMemberCardData: "/api/statMemberBehavior/queryMemberCardData",
    getBIMemberMaxDate: "/api/statMemberBehavior/getBIMemberMaxDate"
}
const statStrategyEffect={
    getDimensStrategyType: "/api/statStrategyEffect/getDimensStrategyType",
    fetchBIStrategyMaxDate: "/api/statStrategyEffect/fetchBIStrategyMaxDate",
    queryStrategySummary: "/api/statStrategyEffect/queryStrategySummary",
    queryStrategyDetail: "/api/statStrategyEffect/queryStrategyDetail"
}
const workflowAPI = {
    getJobinfoList:'/api/workflow/getJobinfoList',
    addSchedule:'/api/workflow/addSchedule',
    updateWorkFlow:'/api/workflow/updateWorkFlow',
    disableWorkFlow:'/api/workflow/disableWorkFlow',
    enableWorkFlow:'/api/workflow/enableWorkFlow',
    addJob:'/api/workflow/addJob',
    getScheduleList:'/api/workflow/getScheduleList',
    getScheduleInsList :'/api/workflow/getScheduleInsList',
    getJobInsList:'/api/workflow/getJobInsList',
    getJobTypeList:'/api/workflow/getJobTypeList',
    getJobListByType:'/api/workflow/getJobListByType',
    getScheduleWorkflow:'/api/workflow/getScheduleWorkflow',
    saveWorkFlow:'/api/workflow/saveWorkFlow'

}

const usedDashboard = {
    getUseCaseDashboard: '/dynames/v1/strategy/getUseCaseDashboard',
    getUseCaseOptionList: '/dynames/v1/strategy/getUseCaseOptionList',
}

export {
    strategyManagementApiV2,
    strategyGroupJob,
    ContentListService,
    launchStrategy,
    coupon,
    operationAnalysis,
    userAnalysis,
    login,
    addUserGroup,
    userProfile,
    roleManagement,
    tagsOverview,
    tagManagement,
    userList,
    userGroupList,
    logEvent,
    tagAuthorityManagement,
    menuButtonManagement,
    sourceMenuManagement,
    homeSetting,
    homeAnalysis,
    areaAuthorityManagement,
    ChannelApply,
    ruleManagement,
    addUserGroupV2,
    customGroupV2,
    resultApi,
    resultDashboard,
    blackWhiteList,
    customizedRemoval,
    couponTag,
    robotTask,
    autoProduct,
    intellControl,
    myTags,
    materialUpload,
    materialLibrary,
    materialDetail,
    materialTagManagement,

    intelligentAll,
    reportLog,
    statMemberBehavior,
    statStrategyEffect,
    workflowAPI,
    editItemUserGroup,
    usedDashboard

}
